
import S3 from 'aws-s3'
export default {
  computed: {
    config(directory) {
      return {
        bucketName: 'obeeweb',
        dirName: directory,
        region: 'ap-southeast-1',
        accessKeyId: 'AKIAXJBKAWAEYQIHMS3U',
        secretAccessKey: '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',
        s3Url: 'https://obeeweb.s3-ap-southeast-1.amazonaws.com'
      }
    },
    S3Client(config) {
      return new S3(config)
    }
  },
  methods: {}
}




// WEBPACK FOOTER //
// ./src/components/S3FileUpload/S3FileUpload.js